import React, { Component, PropTypes } from 'react';
import { ReactGA }  from './App';

const CLASS_NAME = 'btn btn-primary';
 
class Button extends Component {

     static defaultProps = {
        type: 'button',
    };

    static propTypes = {
        type: PropTypes.oneOf(['button', 'submit', 'reset']).isRequired,
        className: PropTypes.string,
        disabled: PropTypes.bool,
        value: PropTypes.string.isRequired,
        dataLink: PropTypes.string,
        gaEvent: PropTypes.string,
        gaCategory: PropTypes.string,
        gaAction: PropTypes.string,
        gaValue: PropTypes.string,
        gaLabel: PropTypes.string
    };

    constructor(props) {
        super(props);
        this.state = {
            disabled: false,
            showLoading: false,
        };
    }

    trackGAEvent() {
        let gaEvent = {}
        if(this.props.gaCategory) gaEvent.category = this.props.gaCategory;

        if(this.props.gaAction)  gaEvent.action = this.props.gaAction;
        if(this.props.gaValue) gaEvent.value = parseInt(this.props.gaValue, 10);
        if(this.props.gaLabel) gaEvent.label = this.props.gaLabel;
        ReactGA.event(gaEvent);
    }

    onClick(event) {
        if(this.props.gaEvent) this.trackGAEvent()
        window.location = event;
    }

    render() {
        const { type, className, disabled, value, faclass, dataLink } = this.props;
        const classNames = !className ? CLASS_NAME : `${CLASS_NAME} ${className}`;

        return (
            <button
                type={type}
                onClick={this.onClick.bind(this, dataLink || '')}
                className={classNames}
                disabled={disabled === true ? disabled : this.state.disabled}
            ><i className={faclass} /> {value}</button>
        );
    }
}

class WAButton extends Component {

    static propTypes = {
        phone: PropTypes.string,
        text: PropTypes.string
    };

    WALink() {
        const {phone, text} = this.props;
        return 'https://api.whatsapp.com/send?phone=' + phone + '&text=' + text;
    }

    render() {
        return(
            <Button dataLink={this.WALink()} className="pd-simple-button pd-green-button" value={this.props.value} gaEvent={this.props.gaEvent} gaCategory={this.props.gaCategory} gaAction={this.props.gaAction} gaValue={this.props.gaValue} gaLabel={this.props.gaLabel} faclass="fa fa-whatsapp fa-lg fa-whatsapp-margin"/>
        );
    }
}

export { WAButton, Button };




/** WEBPACK FOOTER **
 ** ./src/components/Button.js
 **/